import { render, staticRenderFns } from "./NoteRedactorInput.vue?vue&type=template&id=5b0b3602"
import script from "./NoteRedactorInput.vue?vue&type=script&lang=js"
export * from "./NoteRedactorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RedactorInput: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/RedactorInput.vue').default,Toggle: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Toggle.vue').default})
